import { useUserHasAccessToPersonalPlan } from '@legacy/apis/reportingWidgetsAPI';
import scssVariables from '@styles/variables.module.scss';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router';

import { IconButton } from '@/components/ui/IconButton';
import { areaIcons } from '@/constants/areaIcons';
import { designSevenPagePath } from '@/legacy/designSevenPagePath';

export const PersonalPlanButton = () => {
  const { hasAccessToPersonalPlan, isLoading, isError } =
    useUserHasAccessToPersonalPlan();
  const location = useLocation();
  const { t } = useTranslation('personalPlan');

  return hasAccessToPersonalPlan && !isLoading && !isError ? (
    <IconButton
      size="small"
      color="secondary"
      component={Link}
      to={designSevenPagePath.personalPlan}
      state={{ background: location }}
      tooltip={t('HeadingText')}
      data-automation-id="TapBarPersonalPlanButton"
      iconName={areaIcons.personalPlanner}
      iconProps={{ color: scssVariables.ColorBlack100 }}
    />
  ) : null;
};
